//1 = light blue, 2 = blue, 3 = yellow, 4 = red

export const sandals = [
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 3, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 3, 3, 
    0, 0, 0, 0, 0, 1, 1, 1, 1, 3, 3, 3, 
    0, 0, 0, 0, 0, 1, 1, 1, 1, 3, 3, 0, 
    0, 0, 0, 2, 0, 2, 0, 0, 4, 3, 3, 0, 
    0, 2, 0, 2, 0, 2, 0, 0, 4, 3, 5, 0, 
    0, 2, 0, 2, 0, 2, 0, 0, 4, 5, 0, 0, 
    4, 4, 4, 4, 4, 4, 4, 4, 4, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
]